import React, { useState } from 'react';

const ManufacturerRegister: React.FC = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    businessLicense: '',
    contactEmail: '',
    contactPhone: '',
    contactPerson: '',
    industry: '',
    description: '',
    website: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const industries = [
    'Alcohol & Beverages',
    'Food & Snacks',
    'Cosmetics & Personal Care',
    'Pharmaceuticals',
    'Electronics',
    'Textiles & Clothing',
    'Automotive Parts',
    'Home & Garden',
    'Other'
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      // TODO: Replace with actual API call
      const response = await fetch('/api/manufacturers/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        alert('Registration failed. Please try again.');
      }
    } catch (error) {
      alert('Registration failed. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: '40px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '60px 40px',
          borderRadius: '20px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          maxWidth: '600px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '4rem', marginBottom: '24px' }}>✅</div>
          <h1 style={{
            color: '#22c55e',
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '16px'
          }}>
            Registration Submitted!
          </h1>
          <p style={{
            color: '#64748b',
            fontSize: '1.1rem',
            lineHeight: '1.6',
            marginBottom: '30px'
          }}>
            Thank you for registering with ScanOnce! We'll review your application and get back to you within 24-48 hours.
          </p>
          
          <div style={{
            backgroundColor: '#f0fdf4',
            border: '1px solid #bbf7d0',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h3 style={{ color: '#166534', marginBottom: '12px', fontSize: '1.1rem' }}>
              What happens next?
            </h3>
            <ul style={{ color: '#15803d', fontSize: '14px', margin: 0, paddingLeft: '20px' }}>
              <li>We'll verify your business license and contact information</li>
              <li>Our team will reach out within 24-48 hours</li>
              <li>Once approved, you'll receive login credentials</li>
              <li>You can then start uploading your products and batches</li>
            </ul>
          </div>

          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href="/"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                padding: '12px 24px',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                transition: 'transform 0.3s ease'
              }}
            >
              Back to Home
            </a>
            <a
              href="/verify"
              style={{
                backgroundColor: 'white',
                color: '#475569',
                padding: '12px 24px',
                textDecoration: 'none',
                border: '2px solid #e2e8f0',
                borderRadius: '8px',
                fontWeight: '600',
                transition: 'all 0.3s ease'
              }}
            >
              Try Verification
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        {/* Header */}
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '20px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '16px'
          }}>
            Join ScanOnce 2.0
          </h1>
          <p style={{
            color: '#64748b',
            fontSize: '1.1rem',
            lineHeight: '1.6',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Register your company to start protecting your products with our universal verification platform.
          </p>
        </div>

        {/* Benefits Section */}
        <div style={{
          backgroundColor: '#f0fdf4',
          border: '1px solid #bbf7d0',
          borderRadius: '16px',
          padding: '30px',
          marginBottom: '30px'
        }}>
          <h3 style={{
            color: '#166534',
            fontSize: '1.3rem',
            fontWeight: '600',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            Why Choose ScanOnce 2.0?
          </h3>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '8px' }}>🌍</div>
              <h4 style={{ color: '#166534', marginBottom: '8px' }}>Universal Platform</h4>
              <p style={{ color: '#15803d', fontSize: '14px', margin: 0 }}>
                Works with any product - no industry restrictions
              </p>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '8px' }}>💰</div>
              <h4 style={{ color: '#166534', marginBottom: '8px' }}>Affordable Pricing</h4>
              <p style={{ color: '#15803d', fontSize: '14px', margin: 0 }}>
                Just KSh 1 per product token - perfect for SMEs
              </p>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '8px' }}>🔧</div>
              <h4 style={{ color: '#166534', marginBottom: '8px' }}>No Changes Needed</h4>
              <p style={{ color: '#15803d', fontSize: '14px', margin: 0 }}>
                Uses existing barcodes and batch codes
              </p>
            </div>
          </div>
        </div>

        {/* Registration Form */}
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '20px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{
            color: '#1e293b',
            fontSize: '1.5rem',
            fontWeight: '600',
            marginBottom: '30px',
            textAlign: 'center'
          }}>
            Company Registration
          </h2>

          <form onSubmit={handleSubmit}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '20px',
              marginBottom: '20px'
            }}>
              {/* Company Name */}
              <div>
                <label style={{
                  display: 'block',
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}>
                  Company Name *
                </label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none',
                    transition: 'border-color 0.3s ease'
                  }}
                  placeholder="Enter your company name"
                />
              </div>

              {/* Business License */}
              <div>
                <label style={{
                  display: 'block',
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}>
                  Business License Number *
                </label>
                <input
                  type="text"
                  name="businessLicense"
                  value={formData.businessLicense}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                  placeholder="Business registration number"
                />
              </div>

              {/* Contact Email */}
              <div>
                <label style={{
                  display: 'block',
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}>
                  Contact Email *
                </label>
                <input
                  type="email"
                  name="contactEmail"
                  value={formData.contactEmail}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                  placeholder="company@example.com"
                />
              </div>

              {/* Contact Phone */}
              <div>
                <label style={{
                  display: 'block',
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}>
                  Contact Phone *
                </label>
                <input
                  type="tel"
                  name="contactPhone"
                  value={formData.contactPhone}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                  placeholder="+254 XXX XXX XXX"
                />
              </div>

              {/* Contact Person */}
              <div>
                <label style={{
                  display: 'block',
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}>
                  Contact Person *
                </label>
                <input
                  type="text"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none'
                  }}
                  placeholder="Full name of contact person"
                />
              </div>

              {/* Industry */}
              <div>
                <label style={{
                  display: 'block',
                  color: '#374151',
                  fontWeight: '600',
                  marginBottom: '8px'
                }}>
                  Industry *
                </label>
                <select
                  name="industry"
                  value={formData.industry}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    outline: 'none',
                    backgroundColor: 'white'
                  }}
                >
                  <option value="">Select your industry</option>
                  {industries.map((industry) => (
                    <option key={industry} value={industry}>
                      {industry}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Website */}
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                color: '#374151',
                fontWeight: '600',
                marginBottom: '8px'
              }}>
                Website (Optional)
              </label>
              <input
                type="url"
                name="website"
                value={formData.website}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none'
                }}
                placeholder="https://www.yourcompany.com"
              />
            </div>

            {/* Description */}
            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                color: '#374151',
                fontWeight: '600',
                marginBottom: '8px'
              }}>
                Company Description
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows={4}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  outline: 'none',
                  resize: 'vertical'
                }}
                placeholder="Brief description of your company and products..."
              />
            </div>

            {/* Terms and Conditions */}
            <div style={{
              backgroundColor: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '30px'
            }}>
              <p style={{
                color: '#64748b',
                fontSize: '14px',
                margin: 0,
                lineHeight: '1.5'
              }}>
                By registering, you agree to ScanOnce's terms of service and privacy policy. 
                We'll verify your business information and contact you within 24-48 hours 
                with your account details.
              </p>
            </div>

            {/* Submit Button */}
            <div style={{ textAlign: 'center' }}>
              <button
                type="submit"
                disabled={loading}
                style={{
                  background: loading ? '#9ca3af' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  padding: '16px 48px',
                  border: 'none',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: loading ? 0.7 : 1
                }}
              >
                {loading ? 'Submitting...' : 'Register Company'}
              </button>
            </div>
          </form>
        </div>

        {/* Contact Section */}
        <div style={{
          backgroundColor: '#eff6ff',
          border: '1px solid #dbeafe',
          borderRadius: '16px',
          padding: '30px',
          marginTop: '30px',
          textAlign: 'center'
        }}>
          <h3 style={{
            color: '#1e40af',
            fontSize: '1.2rem',
            fontWeight: '600',
            marginBottom: '16px'
          }}>
            Need Help?
          </h3>
          <p style={{
            color: '#1e40af',
            fontSize: '14px',
            marginBottom: '16px'
          }}>
            Have questions about registration or ScanOnce 2.0? We're here to help!
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <a
              href="mailto:karuoyamercy@gmail.com"
              style={{
                color: '#1e40af',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '14px'
              }}
            >
              📧 karuoyamercy@gmail.com
            </a>
            <a
              href="tel:+254114445264"
              style={{
                color: '#1e40af',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '14px'
              }}
            >
              📱 +254 114 445 264
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManufacturerRegister;
